var Tanks = [
  { caption: "tanque", src:"tanque.png" },
  { caption: "tanque-de-condensado", src:"Tanque_de_condensado.png" },
  { caption: "tanque-de-diluicao", src:"tanque_diluicao.png" },
  { caption: "tanque-de-mel", src:"tanque_mel.png" },
  { caption: "tanque-da-volante", src:"Tanque_da_Volante.png" },
  { caption: "tanque-pulmao", src:"Tanque_Pulmao.png" },
]

export default Tanks
